export enum NotificationMethod {
  SMS = "SMS",
  EMAIL = "EMAIL",
  IN_APP = "IN_APP",
}
